import React from 'react'
import {useSelector} from 'react-redux'
import {Fragment} from 'react'
import classNames from 'classnames'
import {useFormContext} from "react-hook-form";
import RenderedHtmlContent from "../../../../shared/virtual_congress/components/rendered_html_content";
import FlaveRadioButton from "./form_fields/raw_fields/flave_radio_button";
import FlaveCheckbox from "./form_fields/raw_fields/flave_checkbox";

const Dsgvo = () => {
  const {formState: { errors }, register} = useFormContext();

  const dsgvo = useSelector(state => state.dsgvo)
  const dsgvoText = useSelector(state => state.dsgvo.text).trim()

  const labelWidth = useSelector(state => state.label_width) || "3"
  const inputWidth = useSelector(state => state.input_width) || "8"
  
  const error = errors?.gdpr_confirmation?.base?.message

  const options = [
    {
      label: <RenderedHtmlContent html={dsgvoText}/>,
      value: "1"
    }
  ]

  return (
    <Fragment>
      {dsgvo.enabled && <FlaveCheckbox
        name={"gdpr_confirmation.base"}
        label={""}
        options={options}
        errorMessage={error}
        />}
    </Fragment>
  )

  // return (
  //   <Fragment>
  //     {dsgvo.enabled &&
  //     <div
  //       key={"coldsgvo"}
  //       id="form-group-gdpr-acception"
  //       className="form-group row r-gdpr"
  //     >
  //       <label className={`col-md-${labelWidth} r-label optional-label col-form-label`}/>
  //
  //       <div className={`col-md-${inputWidth}`}>
  //         <div className="form-check">
  //           <input
  //             ref={register}
  //             id="gdpr_confirmation.base"
  //             name="gdpr_confirmation.base"
  //             type="checkbox"
  //             className={classNames("form-check-input", {"is-invalid": error })}/>
  //           <label htmlFor="gdpr_confirmation.base" className="form-check-label dsgvo-label">
  //             <RenderedHtmlContent html={dsgvoText}/>
  //           </label>
  //           {error && <div className="invalid-feedback"><RenderedHtmlContent html={error}/></div>}
  //         </div>
  //       </div>
  //     </div>
  //     }
  //   </Fragment>
  // )
}
export default Dsgvo;